/**
   *  Loại quyết định phân bổ
   */
export default {
  DecisionBeginYear: 1, //giao đầu năm
  DecisionAdditional: 2 //giao bổ sung
};